import { render } from "./electronic-property-form.vue?vue&type=template&id=3390e255&ts=true"
import script from "./electronic-property-form.vue?vue&type=script&lang=ts"
export * from "./electronic-property-form.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__